var $c290b85db87f794b$exports = {};
$c290b85db87f794b$exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};


export {$c290b85db87f794b$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
